import styled from 'styled-components';
export const InputField = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__InputField",
  componentId: "components-web__sc-1lrz1xk-0"
})(["order:1;text-align:center;z-index:10;input{text-align:center;}"]);
export const InputWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__InputWrapper",
  componentId: "components-web__sc-1lrz1xk-1"
})(["text-align:start;display:flex;flex-direction:row;flex-wrap:nowrap;"]);